var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoWhite = function SvgLogoWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 171,
    viewBox: "0 0 177 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Emblem-White",
    clipPath: "url(#clip0_5739_101876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_5739_101876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7507 94.8379L30.8916 155.611C37.8388 161.586 45.7168 166.509 54.2954 170.096C55.944 133.868 112.141 129.576 90.5158 95.2054C89.678 93.8752 87.8138 93.6792 86.7507 94.8379Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_d_5739_101876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2504 0.822998C39.6324 0.822998 0.217773 40.2377 0.217773 88.8556C0.217773 100.709 2.56697 112.01 6.82199 122.327L33.2707 95.8787C34.3143 94.8352 36.007 94.8352 37.0505 95.8787L57.1988 116.027L87.1113 86.1512C88.0372 85.2277 89.5364 85.2277 90.4599 86.1512L129.566 125.257L154.079 100.744C155.108 99.7148 156.779 99.7148 157.808 100.744L172.266 115.201C174.874 106.882 176.285 98.0344 176.285 88.8531C176.285 40.2376 136.871 0.822998 88.2504 0.822998ZM99.1243 63.7493C95.854 62.8454 92.1649 60.0381 88.2553 60.0136C84.3456 59.9891 80.6516 62.7498 77.3691 63.6145C76.6905 63.7934 76.0193 63.3255 76.1982 62.8086L87.5008 30.2921C87.7555 29.5621 89.1592 29.5719 89.4066 30.3044L100.305 62.958C100.479 63.4774 99.8004 63.9354 99.1243 63.7493Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_d_5739_101876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3038 103.49L10.2905 129.684C10.2905 129.684 12.5099 135.97 18.0534 141.021C18.9157 133.133 25.3239 121.801 33.0256 117.176C39.696 113.169 37.2831 106.369 36.8103 103.936C36.6731 103.231 35.801 102.971 35.3038 103.493V103.49Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter3_d_5739_101876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.204 107.706L134.195 129.887L140.476 136.168C140.476 136.168 143.445 125.703 151.85 118.016C153.797 116.235 156.183 110.584 155.71 108.151C155.573 107.446 154.701 107.186 154.204 107.708V107.706Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5739_101876",
    x: 25.8916,
    y: 89.0764,
    width: 74.5698,
    height: 86.0193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5739_101876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5739_101876",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5739_101876",
    x: -4.78223,
    y: -4.177,
    width: 186.067,
    height: 134.434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5739_101876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5739_101876",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5739_101876",
    x: 5.29053,
    y: 98.2173,
    width: 37.332,
    height: 47.8037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5739_101876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5739_101876",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5739_101876",
    x: 129.195,
    y: 102.433,
    width: 31.5757,
    height: 38.7354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5739_101876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5739_101876",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5739_101876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176.068,
    height: 169.272,
    fill: "white",
    transform: "translate(0.217773 0.823486)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoWhite);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";